enum TransportMode {
    CYCLING = 'cycling',
    DRIVING = 'driving',
    WALKING = 'walking',
}

export default TransportMode